import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Button, Heading, Image, Text, VStack, chakra, Divider,Stack, Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { AppRoutes } from 'Routes/AppRoutes';
import { ILoopBusinessLocalizationDocument } from 'Types/Interface/Sanity';
import useLocalizedNavigate from 'Utils/useLocalizedNavigate';
import welcomeToLoop from 'Assets/Images/welcomeToLoop.png';


interface IServicesProps{
	shouldIgnoreParentPadding: boolean;
	loopBusinessLocalization: ILoopBusinessLocalizationDocument | null;
}

export const Services = ({shouldIgnoreParentPadding, loopBusinessLocalization}:IServicesProps) => {
	const navigate = useLocalizedNavigate();
	
	return(
		<>
			<Box  bg={['none','darkCoral']}  py={['0px','100px']} color="gray.800"  justifyContent={'center'} {...(shouldIgnoreParentPadding && { px:{ base: '30px', xl: '80px','2xl': '192px' }})}>
				<Flex direction={{ base: 'column', lg: 'row' }} >
					<VStack align="flex-start" w={{ base: 'full', lg: '25%' }} spacing={4}>
						<Heading textTransform={'uppercase'} fontSize={['30px','40px']}  fontWeight={'bold'}color={['darkCoral','#ffffff']} mb={['30px', null]}> <chakra.span color={'brand.black'}>Why</chakra.span> Loop?</Heading>
					</VStack>
					<VStack w={{ base: 'full', lg: '75%' }} spacing={12} align="stretch">
						<Flex direction={{ base: 'column', md: 'row' }} >
							<Box w={{ base: 'full', md: '30%' }}>
								<Heading textTransform={'uppercase'} fontSize={['18px','24px']} fontWeight={600} color={['brand.black','#ffffff']} mb={['12px', null]}>{loopBusinessLocalization?.rentedMediaTitle}</Heading>
							</Box>
							<Box w={{ base: 'full', md: '70%' }}>
								<Text fontSize={['16px','20px']} fontWeight={[400,500]} color={['brand.black','#ffffff']}>
									{loopBusinessLocalization?.rentedMediaDescription}
								</Text>
							</Box>
						</Flex>
						<Divider alignSelf={'end'} border={'0.5px'} borderColor={'blackTextColor.100'} w={['100%','67%']} />
						<Flex direction={{ base: 'column', md: 'row' }} >
							<Box w={{ base: 'full', md: '30%' }}>
								<Heading textTransform={'uppercase'} fontSize={['18px','24px']} fontWeight={600} color={['brand.black','#ffffff']} mb={['12px', null]}>{loopBusinessLocalization?.engagementTitle}</Heading>
							</Box>
							<VStack w={{ base: 'full', md: '70%' }} align={'flex-start'} spacing={['30px','10']}>
								<Text fontSize={['16px','20px']} fontWeight={[400,500]} color={['brand.black','#ffffff']}>
									{loopBusinessLocalization?.engagementDescription}
								</Text>
                
								<VStack spacing={['10', null]}  align="flex-start">
									<Heading textTransform={'uppercase'} fontSize={['30px','40px']} fontWeight={700} color={['darkCoral','blackTextColor.100']}>
										{loopBusinessLocalization?.statistics} {loopBusinessLocalization?.statisticsDescription}
									</Heading>
									<Text  fontSize={['16px','20px']} fontWeight={[400,500]} color={['brand.black','#ffffff']}>Which makes them more loyal, more active, and more likely to stay.</Text>
									<Heading textTransform={'uppercase'} fontSize={['30px','40px']} fontWeight={700} color={['darkCoral','blackTextColor.100']}>
										Loop is performance-based
									</Heading>
									<Text  fontSize={['16px','20px']} fontWeight={[400,500]} color={['brand.black','#ffffff']}>We only earn when your customers engage. That means better ROI for you and real value for them.</Text>
									<Button
										w={['auto','220px']}
										h={['50px','60px']}
										bg={'blackTextColor.100'}
										borderColor={'blackTextColor.100'}
										variant={'dark'}
										onClick={() => navigate(AppRoutes.processOverview)}
									>
										How it Works
										<ArrowForwardIcon ml={2} boxSize={[5,5]} />
									</Button>
								</VStack>
							</VStack>
						</Flex>
					</VStack>
				</Flex>
			</Box>
			<Flex direction={['column', null, null, 'row']} alignItems={['center','center']} justifyContent={'space-between'} px={{ base: '30px', xl: '80px', '2xl': '192px' }} mt={['30px','100px']}>
				<Stack align={'flex-start'} spacing={'25px'} py={['40px', '100px']} w={['100%', null, null,'45%']}>
					<Heading textTransform={'uppercase'} alignSelf={'flex-start'} fontSize={['30px','40px']}  fontWeight={'bold'} >Why <chakra.span color={'darkCoral'}>Loop</chakra.span>  Changes Everything...</Heading>
					
					{loopBusinessLocalization?.whatMakesLoopDifferentItem.map((item, id) => {
						return(
							<Text key={item + id} fontSize={['16px','18px']}>
								{item}
							</Text>
						);
					})};
				</Stack>
				<Image objectFit={'cover'} borderRadius={'3px'} src={welcomeToLoop} w={['388px','100%', null,'620px']} h={['450px','610px']} />
			</Flex>
			
		</>
	);
};